exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-list__tile__action[data-v-3dd49cea] {\n  min-width: auto;\n}", ""]);

// exports
